module.exports = __webpack_public_path__ + "static/bible-verse-d4d961ab9882590501c1a923aedc477c.jpg";